<template>
    <div class="main">
        <c-panel>
            <form-pdi :paramId="$route.params.id" v-on:onSubmit="onSubmit"></form-pdi>
        </c-panel>
    </div>
</template>

<script>
import formPdi from './form'

export default {
    methods: {
        onSubmit () {
            this.$router.push('/admin/pedagogico/pdi')
        }
    },
    components: { formPdi }
}
</script>
